import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getWoundDashBoardWoundcount, setWoundReportPayload } from "../app/woundReportSlice";
import { Report } from "../components/core/WoundReport/report";
import { Tab as TabComponent } from "../components/secondary";
import { Header } from "../components/secondary/Header";
import style from "./woundReport.module.scss";
import { useExternalUserRedirect } from "../hooks/useExternalUserRedirect";
import { WoundReportForm } from "./WoundReport/woundReportForm";
import { WoundReportCard } from "./WoundReport/woundReportCard";

const REPORT_TAB_CONFIG = [
  { label: "New", key: "new" },
  { label: "Improving", key: "improving" },
  { label: "Stable", key: "stable" },
  { label: "Stalled", key: "stalled" },
  { label: "Deteriorating", key: "detoriating" },
  { label: "Monitoring", key: "monitoring" },
  { label: "Resolved", key: "resolve" },
];

export const WoundReport = () => {
  const dispatch = useDispatch();

  useExternalUserRedirect();

  const woundReportPayload = useSelector((state) => state.woundreport.woundReportPayload);
  const woundCountData = useSelector((state) => state.woundreport.woundCountData);

  const [tempPayload, setTempPayload] = useState("");
  const [selectedDivOption, setSelectedDivOption] = useState(
    woundReportPayload?.optionSelected ? woundReportPayload?.optionSelected : "Patients with Wound"
  );
  const [woundProgressValue, setWoundProgressValue] = useState(woundReportPayload?.woundProgress ? woundReportPayload?.woundProgress : "new");
  const [tabIndex, setTabIndex] = useState(woundReportPayload?.tabIndex ? woundReportPayload?.tabIndex : 0);

  const optionSelected = (e) => {
    setTabIndex(woundReportPayload?.tabIndex ? woundReportPayload?.tabIndex : 0);
    setWoundProgressValue(woundReportPayload?.woundProgress ? woundReportPayload?.woundProgress : "new");
    setSelectedDivOption(e);
    let wountCountPayload = { ...tempPayload, optionSelected: e };
    dispatch(setWoundReportPayload({ ...woundReportPayload, optionSelected: e }));
    setTempPayload(wountCountPayload);
    dispatch(getWoundDashBoardWoundcount(wountCountPayload));
    setTempPayload(wountCountPayload);
  };

  const tabList = REPORT_TAB_CONFIG?.map(({ label, key }) => ({
    name: (
      <>
        {label} <span>{woundCountData[key]}</span>
      </>
    ),
    content: <Report woundProgressValue={woundProgressValue} tempPayload={tempPayload} selectedDivOption={selectedDivOption} />,
    className: style.tab_none,
  }));

  const onSelectedTab = (e) => {
    const selectedTab = { 0: "new", 1: "improving", 2: "stable", 3: "stalled", 4: "deteriorating", 5: "monitoring", 6: "resolved" };
    setTabIndex(e);
    setWoundProgressValue(selectedTab[e]);
    dispatch(setWoundReportPayload({ ...woundReportPayload, tabIndex: e, woundProgress: selectedTab[e] }));
  };

  return (
    <>
      <div className="right_block">
        <Header reportHeading={"Wounds Dashboard"} />
        <div className={`col ${style.wound_dashboard} mt-0`}>
          <WoundReportForm
            setTempPayload={setTempPayload}
            selectedDivOption={selectedDivOption}
            setSelectedDivOption={setSelectedDivOption}
            setWoundProgressValue={setWoundProgressValue}
            setTabIndex={setTabIndex}
          />
          <WoundReportCard optionSelected={optionSelected} selectedDivOption={selectedDivOption} />
          <TabComponent
            onSelect={onSelectedTab}
            defaultIndex={tabIndex ? tabIndex : 0}
            selectedIndex={tabIndex}
            tabList={tabList}
            woundReportView={true}
            workListView={true}
          />
        </div>
      </div>
    </>
  );
};
